import axios from 'axios';
import { API_URL } from '../constants';
import { useInterceptor } from './apiUtils';

useInterceptor(axios);

export function getGroupTours(params) {
  return axios({ method: 'get', url: `${API_URL}/group_tours`, params: params || {} });
}

export function showGroupTour(id) {
  return axios({ method: 'get', url: `${API_URL}/group_tours/${id}` });
}

export function createGroupTour(data) {
  return axios({ method: 'post', url: `${API_URL}/group_tours`, data: { group_tour: data } });
}

export function updateGroupTour(id, data) {
  return axios({ method: 'put', url: `${API_URL}/group_tours/${id}`, data: { group_tour: data } });
}

export function deleteGroupTour(id) {
  return axios({ method: 'delete', url: `${API_URL}/group_tours/${id}` });
}

/** Partner: list group tours assigned to me (vendor). Optional year_month for period filter. */
export function getMyGroupTours(params) {
  return axios({ method: 'get', url: `${API_URL}/group_tours/my`, params: params || {} });
}

/** Admin: assign vendor (partner) to this group tour. Only when group is formed. */
export function assignPartnerToGroupTour(id, data) {
  return axios({ method: 'put', url: `${API_URL}/group_tours/${id}/assign_vendor`, params: data });
}

/** Admin: clear vendor assignment when vendor has not confirmed. Lets you assign a different vendor. */
export function unassignPartnerFromGroupTour(id) {
  return axios({ method: 'put', url: `${API_URL}/group_tours/${id}/unassign_vendor` });
}

/** Partner: mark this group tour assignment as complete (informational only). */
export function markCompleteGroupTour(id) {
  return axios({ method: 'put', url: `${API_URL}/group_tours/${id}/mark_complete` });
}

/** Admin: mark assignment complete for payout (creates credit, shows in Balance Due). */
export function adminMarkCompleteGroupTour(id) {
  return axios({ method: 'put', url: `${API_URL}/group_tours/${id}/admin_mark_complete` });
}

/** Admin: approve vendor listing (sets approved, published). */
export function approveGroupTour(id) {
  return axios({ method: 'put', url: `${API_URL}/group_tours/${id}/approve` });
}

/** Admin: reject vendor listing (rejection_reason required). */
export function rejectGroupTour(id, rejectionReason) {
  return axios({ method: 'put', url: `${API_URL}/group_tours/${id}/reject`, data: { rejection_reason: rejectionReason } });
}

/** Stop only this batch from creating next (auto_create_next = false). Admin or vendor owner. */
export function stopBatchGroupTour(id) {
  return axios({ method: 'put', url: `${API_URL}/group_tours/${id}/stop_batch` });
}

/** Stop entire series (all future batches). Admin or vendor owner. */
export function stopSeriesGroupTour(id) {
  return axios({ method: 'put', url: `${API_URL}/group_tours/${id}/stop_series` });
}
